import { RoutingConfig } from 'src/app/utils/routing-config';
import { Component, OnInit } from '@angular/core';
import { dev } from '../../../../config/offlines_keys.json';
import { Preferences } from '@capacitor/preferences';
import { HttpErrorResponse } from '@angular/common/http';
import { FarmAPI } from 'src/app/apis/farm.service';
import { Router } from '@angular/router';
import { Farm } from '../../../../models/farm/farm.model';
import routes from '../../../../config/routing.json';
import Owner from 'src/app/models/owner.model';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { updateOwnerAndFarmCluster } from 'src/app/utils/states-management/actions/owner.action';
@Component({
  selector: 'app-farm-ownership',
  templateUrl: './farm-ownership.component.html',
  styleUrls: ['./farm-ownership.component.scss'],
})
export class FarmOwnershipComponent implements OnInit {
  owner_nature;
  isDashboardView;
  constructor(
    private router: Router,
    private farmAPI: FarmAPI,
    private routingConfig: RoutingConfig,
    private store: Store<{ farm: Farm; owner: Owner }>

  ) { }
  farmInfo = {
    farm_access_road_question: null,
    irrigation_system_question: null,
    water_access_question: null
  }
  ownerSubscription$;
  owner: Owner;
  farm
  async ngOnInit() {
    this.isDashboardView = this.router.url.includes(routes.dashboard.home)
    this.ownerSubscription$ = this.store.select('owner').subscribe(async (owner: any) => {
      this.owner = cloneDeep(owner);

      if (this.owner?.profile_info)
        this.farmInfo = JSON.parse(this.owner?.profile_info)?.farm_info;
    })

  }

  async previous() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }

  async submit(navigate = true) {
    console.log(this.farmInfo);
    this.owner.profile_info = JSON.stringify({
      ...JSON.parse(this.owner?.profile_info),
      farm_info: this.farmInfo
    });
    this.store.dispatch(
      updateOwnerAndFarmCluster({
        data: {
        },
        profile_info: this.owner.profile_info,
      })
    );
    this.router.navigateByUrl(await this.routingConfig.getNextUrl());

  }
  ownershipChange() {
    this.submit(false);
  }
}
